// @flow
import React, { Component } from 'react';
import { Grid, Form } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import './TreatmentActionForm.scss';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import _ from 'lodash';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNode: string,
  subActionIndex: number,
  onModelChange: (_?: Object) => void,
  handleInputChange: Function,
  handleControlBlur: Function,
  listRuleTypes: Object,
  parentKeyList: Array<string>,
  eventType: string,
};

const txAmountKey = 'txAmount';
const incrementTypeList = [
  { key: 'occurrence', value: 'occurrence', text: 'Occurrence' },
  { key: txAmountKey, value: 'txAmount', text: 'Tx Amount' },
];

@formComponent()
export default class ActionUpdateQuest extends Component {
  props: Props;

  getAllowedIncrementTypes = (): Array<string> => {
    const { listRuleTypes, model, parentKeyList, eventType } = this.props;
    const rootParentKey = _.get(parentKeyList, '[0]');
    const scenarios = _.get(model, `nodes[${rootParentKey}].data.scenarios`, []);
    const eventTypes = _.map(scenarios, scenario => _.get(scenario, 'name')); // Used for multiple sub-scenarios. If the component is opened up from Holos then this will be empty.
    eventTypes.push(eventType); // this is the first event in case of multiple sub-scenarios. To support Holos.
    const uniqueEventTypes = _.union(eventTypes);
    const targetUserType = _.get(model, 'targetUserType');

    let disableTxAmountOption = false;
    _.some(uniqueEventTypes, (eventType) => {
      const eventConditionAction = _.find(_.get(listRuleTypes, targetUserType, []), { eventType });
      const eventRuleTypes = _.get(eventConditionAction, 'ruleTypes');
      const hasTxAmountCondition = _.find(eventRuleTypes, { variableName: 'var.payment.transactionValue' });
      if (!hasTxAmountCondition) {
        disableTxAmountOption = true;
      }
      return disableTxAmountOption;
    });

    const allowedIncrementTypeList = _.cloneDeep(incrementTypeList);
    if (disableTxAmountOption) {
      _.remove(allowedIncrementTypeList, { key: txAmountKey });
    }
    return allowedIncrementTypeList;
  }

  render() {
    const { model, currentNode, subActionIndex } = this.props;
    const allowedIncrementTypeList = this.getAllowedIncrementTypes();
    return (
      <div className="treatment-form">
        <div>
          <br />
          <Form>
            <Grid columns="equal">
              <Grid.Column width={5}>
                <FormInputWithError
                  name={`nodes.${currentNode}.data.${subActionIndex}.meta.updateQuestPayload.challengeID`}
                  {...this.props}
                >
                  <Form.Input
                    required
                    label="Challenge ID"
                    value={_.get(model, `nodes[${currentNode}].data[${subActionIndex}].meta.updateQuestPayload.challengeID`)}
                    onChange={this.props.handleInputChange}
                    onBlur={this.props.handleControlBlur}
                  />
                </FormInputWithError>
              </Grid.Column>
              <Grid.Column width={5}>
                <FormInputWithError
                  name={`nodes.${currentNode}.data.${subActionIndex}.meta.updateQuestPayload.taskID`}
                  {...this.props}
                >
                  <Form.Input
                    required
                    label="Task ID"
                    value={_.get(model, `nodes[${currentNode}].data[${subActionIndex}].meta.updateQuestPayload.taskID`)}
                    onChange={this.props.handleInputChange}
                    onBlur={this.props.handleControlBlur}
                  />
                </FormInputWithError>
              </Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column width={4}>
                <FormInputWithError
                  name={`nodes.${currentNode}.data.${subActionIndex}.meta.updateQuestPayload.incrementType`}
                  {...this.props}
                >
                  <Form.Select
                    required
                    label="Increment Type"
                    options={allowedIncrementTypeList}
                    value={_.get(model, `nodes[${currentNode}].data[${subActionIndex}].meta.updateQuestPayload.incrementType`)}
                    onChange={this.props.handleInputChange}
                    onBlur={this.props.handleControlBlur}
                  />
                </FormInputWithError>
              </Grid.Column>
            </Grid>
          </Form>
        </div>
      </div>
    );
  }
}
